import React, { Component } from 'react'
import '../styles/Footer.css'
import Contact from './Contact'
import { injectIntl, defineMessages } from "react-intl"
import { Link } from 'react-router-dom'
import { webURL } from '../webURL'
import LearnMoreButton from './LearnMoreButton'
import PictoSmile from '../images/icons/pictosmile.png'

class Footer extends Component {
  render() {
    const {intl:{formatMessage}} = this.props
    return (
      <div className="footer">
        <div className="questions">
          <img src={PictoSmile} className="smile-icon" alt="smile-icon" />
          <h3>{formatMessage(messages.questions)}</h3>
          <h2>{formatMessage(messages.answers)}</h2>
          <div className="learn-more-faq">
            <Link to="/faq/">
              <LearnMoreButton text={formatMessage(messages.goToFAQ)} />
            </Link>
          </div>
        </div>
        <Contact />
		<div className="footer-bottom">
			<ul className="footer-navigationbottom">
            <li><a rel="noopener noreferrer" href={`${webURL}escape-game-horreur/`}>Escape game horreur Paris</a></li>
            <li><a rel="noopener noreferrer" href={`${webURL}pass-culture-escape-game-paris/`}>Pass culture</a></li>
			<li><a rel="noopener noreferrer" href="https://escape-game-paris.one-hour.fr/2023/06/09/cheque-vacances-escape-game-paris/">Chèques Vacances</a></li>
            <li><a rel="noopener noreferrer" href={`${webURL}escape-game-deux-joueurs/`}>Escape game 2 joueurs</a></li>
            <li><a rel="noopener noreferrer" href={`${webURL}escape-game-coupon-cadeau-entreprise/`}>Achat groupé comité entreprise</a></li>
            <li><a rel="noopener noreferrer" href={`${webURL}location-decor-tournage/`}>Location tournage et shooting</a></li>
            <li><a rel="noopener noreferrer" href={`${webURL}cadeau-noel-escape-game/`}>Cadeau Noël Escape Game</a></li>
          </ul>
		</div>
        <div className="footer-container">
          <div className="footer-social">
            <p>{formatMessage(messages.followUs)}</p>
            <div className="social-icons">
              <a target="_blank" rel="noopener noreferrer" alt="Facebook"
                href="https://www.facebook.com/onehourliveescapegame/"
                className="icon-container">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a target="_blank" rel="noopener noreferrer" alt="Twitter"
                href="https://twitter.com/onehour_escape"
                className="icon-container">
                <i className="fab fa-twitter"></i>
              </a>
              <a target="_blank" rel="noopener noreferrer" alt="Tripadvisor"
                href="https://www.tripadvisor.fr/Attraction_Review-g187147-d8843110-Reviews-One_Hour_Live_Escape_Game-Paris_Ile_de_France.html"
                className="icon-container">
                <i className="fab fa-tripadvisor"></i>
              </a>
              <a target="_blank" rel="noopener noreferrer" alt="Instagram"
                href="https://www.instagram.com/onehour_escape/"
                className="icon-container">
                <i className="fab fa-instagram"></i>
              </a>
            </div>
          </div>
          <ul className="footer-navigation">
            <li><a rel="noopener noreferrer" href="https://escape-game-paris.one-hour.fr">{formatMessage(messages.blog)}</a></li>
            <li><a rel="noopener noreferrer" href={`${webURL}recrutement/`}>{formatMessage(messages.hiring)}</a></li>
            <li><a rel="noopener noreferrer" href={`${webURL}presse/`}>{formatMessage(messages.press)}</a></li>
            <li><Link to="/faq/">{formatMessage(messages.faq)}</Link></li>
            <li><a rel="noopener noreferrer" href={`${webURL}conditions-generales-de-vente/`}>{formatMessage(messages.businessTerms)}</a></li>
            <li><a rel="noopener noreferrer" href={`${webURL}gamedesign-creation-de-live-escape-game/`}>Gamedesign</a></li>
            <li><a rel="noopener noreferrer" href={`${webURL}plan-du-site/`}>{formatMessage(messages.siteMap)}</a></li>
            <li><a rel="noopener noreferrer" href={`${webURL}mentions-legales/`}>{formatMessage(messages.generalConditions)}</a></li>
          </ul>
        </div>
      </div>
    )
  }
}

const messages = defineMessages({
  questions: {
    id: 'landing.cta',
    defaultMessage: 'Vous avez un doute, une question ?'
  },
  answers: {
    id: 'landing.answers',
    defaultMessage: 'Nous avons la réponse !'
  },
  goToFAQ: {
    id: 'landing.goToFAQ',
    defaultMessage: 'Aller à la FAQ'
  },
  followUs: {
    id: 'footer.followUs',
    defaultMessage: 'Suivez-nous'
  },
  blog: {
    id: 'footer.blog',
    defaultMessage: 'Blog'
  },
  hiring: {
    id: 'footer.hiring',
    defaultMessage: 'Recrutement'
  },
    press: {
    id: 'footer.press',
    defaultMessage: 'Presse'
  },
    faq: {
    id: 'footer.faq',
    defaultMessage: 'FAQ'
  },
    businessTerms: {
    id: 'footer.businessTerms',
    defaultMessage: 'CGV'
  },
    siteMap: {
    id: 'footer.siteMap',
    defaultMessage: 'Plan du site'
  },
    generalConditions: {
    id: 'footer.generalConditions',
    defaultMessage: 'Mentions Légales'
  }
})

export default injectIntl(Footer)



// WEBPACK FOOTER //
// ./src/components/Footer.js